import { SegNotificacaoModel } from '@/models/message/seg-notificacao.model';
import api from '@/services/axios/api';
import { AxiosResponse } from 'axios';

class SegNotificacaoService {
  async listByUser(): Promise<SegNotificacaoModel[]> {
    const result = await api.get<SegNotificacaoModel[]>('/segnotificacao/ListByUser');
    return result.data;
  }

  inserir(notificacao: SegNotificacaoModel): Promise<AxiosResponse> {
    return api.post('/segnotificacao', notificacao);
  }

  excluirTodas(): Promise<AxiosResponse> {
    return api.delete('/segnotificacao/excluirTodas');
  }

  delete(id: string): Promise<AxiosResponse> {
    return api.delete('/segnotificacao/' + id);
  }
}
export const serviceNotificacao = new SegNotificacaoService();
